import { render, staticRenderFns } from "./PartnerPaymentDetails.vue?vue&type=template&id=63353d82"
import script from "./PartnerPaymentDetails.vue?vue&type=script&lang=js"
export * from "./PartnerPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports